import axiosContentStudio from '@/utils/axiosContentStudio';

export type Folder = {
  id: string;
  name: string;
  filesCount: number;
  createdAt: Date;
  updatedAt: Date;
};
type FoldersRequest = {
  sort_by?: 'name' | 'updated_at';
  sort_order?: 'asc' | 'desc';
  updated_hours_ago?: number;
  limit?: number;
};

const folderFetchers = {
  getFolders: async (request: FoldersRequest) => {
    const response = await axiosContentStudio.get<{folders: Folder[]}>(
      '/api/v1/folders',
      {
        params: request,
      }
    );
    return response.data;
  },
};

export default folderFetchers;
